
 <!-- After enabling this please update the css/theme in app.scss file. Find notif-custom-class  -->
<notif-library *ngIf="isLoaded && isProduction" 
    [timeout]="notificationFadeOutTime" 
    [showLogo]="false" position="bottom-right" 
    mobilePosition="bottom" className="notif-custom-class" 
    sseUrl="{{ notificationUrl }}">
</notif-library>
<app-header> </app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
